import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getCookies, refreshTokens, removeCookies } from '../fetcher/tokenHandler';

const baseURL = `${process.env.REACT_APP_PUBLIC_BASE_URL}/api`;

const baseQuery = fetchBaseQuery({
  baseUrl: baseURL,
  prepareHeaders: (headers) => {
    const { token, xSwitchUser } = getCookies();
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }

    if (xSwitchUser) {
      headers.set('x-switch-user', xSwitchUser);
    }
    return headers;
  },
});

const customBaseQuery = async (args, api, extra) => {
  const { token: requestToken } = getCookies();
  let result = await baseQuery(args, api, extra);
  const unauthError = result.error && result.error.status === 401;
  const { token, refreshToken } = getCookies();
  if (unauthError && !token && !refreshToken && window.location.pathname !== '/giris') {
    sessionStorage.setItem('returnURL', window.location.pathname);
    window.location.href = '/giris';
  } else if (unauthError && token && !refreshToken) {
    sessionStorage.setItem('returnURL', window.location.pathname);
    removeCookies();
    window.location.href = '/giris';
  } else if (unauthError && refreshToken) {
    try {
      await refreshTokens(requestToken);
      result = await baseQuery(args, api, extra);
    } catch {
      removeCookies();
      window.location.href = '/giris';
    }
  }
  return result;
};

const apiInstance = createApi({
  reducerPath: 'api',
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'Activities',
    'AcedemicTitles',
    'AuthorArticles',
    'AuthorTasks',
    'OrderRevertReasons',
    'Projects',
    'Roles',
    'StiplatedTimes',
    'AuthorWorks',
    'CommitteeOpinions',
    'Version',
    'CommitteeRevertReasons',
    'ArticleGroups',
    'Committee',
    'Committees',
    'CommitteesByCategory',
    'CurrentUser',
    'ArticleOffers',
    'ArticleOfferDetail',
    'ArticleContentSend',
    'Contract',
    'ArticleOrderMeet',
    'CommitteeGiveOpinion',
    'UserList',
    'AskedCommittees',
    'ArticleChains',
    'ArticleTypes',
    'CommitteeCategories',
    'Author',
    'UserAutoComplete',
    'ArticleOfferGuides',
    'ArticleOffersProcess',
    'ArticleOfferContentTemplate',
    'ActivitiesList',
    'Medias',
    'Guides',
    'Hash',
    'DisposalContracts',
    'AfterCopyRightAssignment',
    'AfterCopyRightAssignmentFields',
    'Authors',
    'AuthorsInfinite',
    'SupervisorStiplatedTimes',
    'SupervisorOpinion',
    'RelationGroups',
    'MediaOffers',
    'MediaOfferDetail',
    'ArticleRelationManagement',
    'ArticleRelationManagementDetail',
    'ArticleRelationOverview',
    'ArticleRelationOverviewDetail',
    'ArticleUnifiedRelations',
  ],
});

export default apiInstance;
